<header class="header">
  <!-- Left side -->
  <div class="header-left">
    <ng-container *ngIf="isHomePage">
      <div class="logo" (click)="openSutcWeb()">
        <img src="assets/images/BDO.svg" alt="BDO Logo" class="bdo-logo">
      </div>
    </ng-container>
    <ng-container *ngIf="!isHomePage && hasAccess && !isEntityLocked">
      <button class="home-button" type="button" (click)="homeClicked.emit()">
        <i class="ph ph-house"></i>
        Home
      </button>
    </ng-container>
  </div>

  <!-- Right side -->
  <div class="header-right">
    <button class="theme-toggle-button" type="button" (click)="themeService.toggleTheme()" title="Toggle theme">
      <i class="ph ph-sun"></i>
    </button>
    <button
      *ngIf="hasAccess && !isEntityLocked"
      class="save-button"
      type="button"
      (click)="saveService.save()"
      [disabled]="isSaveDisabled"
      [class.saving-cursor]="saveService.isSaving()"
    >
      <i *ngIf="saveService.isSaving()" class="ph ph-spinner save-spinner"></i>
      <i *ngIf="!saveService.isSaving()" class="ph ph-floppy-disk"></i>
      <span *ngIf="!saveService.isSaving()">Save</span>
      <span *ngIf="saveService.isSaving()">Saving...</span>
    </button>
  </div>
</header>

<div class="header-details" *ngIf="isEntityLocked || hasAccess">
  <div class="company-returns-container">
    <h4 class="entity-name">{{ workpaperInfo?.ReportingGroupName || workpaperInfo?.EntityName || '' }}</h4>
    <div class="body-small returns-count">(Returns {{ returnsCount }})</div>
  </div>

  <div class="period-selector">
    <span class="calendar-icon">
      <i class="ph ph-calendar-dots"></i>
    </span>
    <span class="period-title body-small">Period</span>
    <span class="period body-small">{{ currentPeriod }}</span>

    <button
      *ngIf="canRenderLockControl"
      type="button"
      class="lock-toggle-button"
      [disabled]="isLockControlDisabled"
      [title]="lockControlTitle"
      (click)="onToggleActiveSheetLock()"
      aria-label="Toggle active sheet lock"
    >
      <i
        class="ph"
        [ngClass]="[lockControlIconClass, isLockActionInProgress ? 'spinning' : '']"
      ></i>
    </button>
  </div>

  <div
    *ngIf="lockControlMessage"
    class="lock-control-message body-small"
  >
    {{ lockControlMessage }}
  </div>

  <div
    *ngIf="saveService.saveMessage() && saveService.saveMessage().length > 0"
    [ngClass]="{'save-feedback-success': saveService.saveMessageType() === 'success', 'save-feedback-error': saveService.saveMessageType() === 'error'}"
    class="save-feedback-message body-small"
  >
    {{ saveService.saveMessage() }}
  </div>
</div>